// extracted by mini-css-extract-plugin
export default {"fullWidth":"wp-z","image":"xp-z","lazyLoadPicture":"yp-z","lazyLoadSpinner":"zp-z","lazyLoadSpin":"Ap-z","lazyLoadImage":"Bp-z","hasStyledAspectRatio":"Cp-z"};